import { PropositionInterfaceType } from '../../lib/models/api/proposition-interface-type.model';
import { Deserializable } from '../../lib/models/deserializable';
import { ProductPickerFilterDto } from './product-picker-filter-dto.model';

export class ProductPickerDto implements Deserializable {
  public RemortgageEstimatedPropertyValue?: number;
  public PurchasePropertyPrice?: number;
  public LoanAmount?: number;
  public InterestOnlyPart?: number;
  public LoanTermYears?: number;
  public LoanTermMonths?: number;
  public RepaymentTypeCode: string;
  public PurchasingAtConcessionaryPriceCode: string;
  public TrueMarketPrice?: number;
  public ArrangementFeeIncludedCode: string;
  public SelectedProductId: number;
  public Filter: ProductPickerFilterDto;
  public PropositionInterfaceType: PropositionInterfaceType;
  public IsAdvised: boolean;
  public IsBuyToLetMortgageType: boolean;
  public Ltv: number;
  public RepaymentPart: number;
  public PropertyEPCRatingCode: string;
  public EPCDateIssued?: Date;
  public ApplicationStage?: number;

  deserialize(input: any): this {
    Object.assign(this, input);
    this.Filter = new ProductPickerFilterDto().deserialize(input.Filter);
    this.PropositionInterfaceType = new PropositionInterfaceType().deserialize(input.PropositionInterfaceType);

    return this;
  }
}
